import request, { getExcel } from '@/utils/request'
import {
  PostBrandListRes,
  GetPromotionStatusListRes,
  PatchStopPromotionRes,
  PostPromotionListReq,
  PostPromotionListRes,
  PostPromotionReq,
  PostPromotionRes,
  PutPromotionReq,
  PutPromotionRes,
  GetServiceTypeListRes,
  GetPromotionChargeBaseRes,
  PromotionSettlementSummaryReq,
  PromotionSettlementSummaryRow,
  PromotionSettlementLineReq,
  PromotionSettlementLineRes,
  PromotionBulkValidateRes,
  PromotionBulkRegisterRes,
} from '@/services/settlement/settlementPromotion/types'
import { omit } from 'lodash-es'

export const postPromotionList = async (params: ApiPaginationReq<PostPromotionListReq>) =>
  await request.post<ApiPaginationV2<PostPromotionListRes>, ApiPaginationReq<PostPromotionListReq>>(`/api2/mass/v1/promotions/search`, params)

export const postPromotion = async (params: PostPromotionReq) =>
  await request.post<PostPromotionRes, PostPromotionReq>(`/api2/mass/v1/promotions`, params)

export const postMFSPartnerList = async () => await request.post<ApiResponseV2<{ partnerIds: string[] }>>(`/api/v1/get-mfs-partners`, {})

export const postBrandList = async (params: { partnerIds?: string[] }) =>
  await request.post<ApiResponseV2<PostBrandListRes>, { partnerIds?: string[] }>(`/api/v1/get-brands`, params)

// LOGISPRD-10354 — 프로모션 할인 집계 목록 (promotion_daily_settlement_summary 기간 합산)
export const postPromotionSettlementSearch = async (params: PromotionSettlementSummaryReq) =>
  await request.post<ApiPaginationV2<PromotionSettlementSummaryRow>, PromotionSettlementSummaryReq>(
    `/api2/mass/v1/promotions/settlements/search`,
    params,
  )

// LOGISPRD-11359 — 프로모션 할인 라인 (원본 일정산 6종 통합, 여러 프로모션이 한 페이지에 섞임)
export const postPromotionSettlementDetails = async (params: PromotionSettlementLineReq) =>
  await request.post<ApiResponseV2<PromotionSettlementLineRes>, PromotionSettlementLineReq>(
    `/api2/mass/v1/promotions/settlements/details`,
    params,
  )

export const getServiceTypeList = async () => await request.get<ApiResponseV2<{ items: GetServiceTypeListRes[] }>>(`/api2/mass/v1/service-types`)

// LOGISPRD-11315 — 등록 가능한 (국가 · 주문유형 · 서비스 항목 · 정산 단위) 조합
export const getPromotionChargeBases = async () =>
  await request.get<ApiResponseV2<{ items: GetPromotionChargeBaseRes[] }>>(`/api2/mass/v1/promotions/charge-bases`)

export const getPromotionStatusList = async () =>
  await request.get<ApiResponseV2<{ items: GetPromotionStatusListRes[] }>>(`/api2/mass/v1/promotions/statuses`)

export const putPromotion = async (params: PutPromotionReq) =>
  await request.put<ApiResponseV2<PutPromotionRes>, Omit<PutPromotionReq, 'promotionId'>>(
    `/api2/mass/v1/promotions/${params.promotionId}`,
    omit(params, 'promotionId'),
  )

export const patchStopPromotion = async (params: { promotionIds: number[] }) =>
  await request.patch<PatchStopPromotionRes, { promotionIds: number[] }>(`/api2/mass/v1/promotions/stop`, params)

// 프로모션 엑셀 일괄 등록 — 계약은 mass-settlement 스웨거 paths/promotion/promotions-bulk*.yml
export const postPromotionBulkValidate = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return await request.post<ApiResponseV2<PromotionBulkValidateRes>, FormData>(`/api2/mass/v1/promotions/bulk/validate`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// 검증 결과 다운로드 — 서버가 올린 파일 오른쪽에 결과 열을 붙여 전 행을 그대로 내려준다.
// 화면 표를 떨구면 안내 행·헤더 위치·드롭다운이 사라져 그 파일을 다시 올릴 수 없다
export const postPromotionBulkResult = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return await getExcel(`/api2/mass/v1/promotions/bulk/result`, {
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// 등록도 파일을 보낸다 — 서버가 검증 결과를 들고 있지 않다 (인스턴스가 여러 개여도 등록이 실패하지 않게)
export const postPromotionBulkRegister = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return await request.post<ApiResponseV2<PromotionBulkRegisterRes>, FormData>(`/api2/mass/v1/promotions/bulk`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

